import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DistributorService } from '../distributor.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { ControlItem } from 'src/app/models/frontend';
import { CountryService } from '../../countries/country.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-distributor',
  templateUrl: './create-distributor.component.html',
  styleUrls: ['./create-distributor.component.scss']
})
export class CreateDistributorComponent {
  errors: string[] | null = null;
  eventForm: FormGroup

  country:any
  countryList:ControlItem[]=[]

  constructor(
    public distributorService: DistributorService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    public countryService:CountryService,private toastr:ToastrService
  ) {
    this.LoadCountries()
  }
  ngOnInit() {
    this.eventForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.maxLength(100)]],
      lastName: ['', [Validators.required, Validators.maxLength(100)]],
      fullName: ['', [Validators.required, Validators.maxLength(100)]],
      email: ['', [Validators.required, Validators.maxLength(100)]],
      phoneNo: ['', [Validators.required, Validators.maxLength(100)]],
      address: ['', [Validators.required, Validators.maxLength(100)]],
      city: ['', [Validators.required, Validators.maxLength(100)]],
      zipCode: ['', [Validators.required, Validators.maxLength(100)]],
      countryId: [null, [Validators.required, Validators.maxLength(100)]],

    });
  }

  onSubmit() {
    const roleTypeNumber = parseInt("2", 10);
    const countryIdNumber = parseInt(this.eventForm.value.countryId, 10);
    this.eventForm = this.fb.group({
      firstName: this.eventForm.value.firstName,
      lastName: this.eventForm.value.lastName,
      email: this.eventForm.value.email,
      address: this.eventForm.value.address,
      fullName: this.eventForm.value.fullName,
      phoneNo: this.eventForm.value.phoneNo,
      // roleType: roleTypeNumber,
      city:this.eventForm.value.city,
      countryId:countryIdNumber,
      zipCode:this.eventForm.value.zipCode,
      IsActive: true,
    })
    console.log(this.eventForm.value)
    this.distributorService.CreateDistributor(this.eventForm.value)
      .subscribe({
        next: r => {
          // Swal.fire('Created', '', 'success')
          this.toastr.success('Created','Success');
          this.activeModal.close({ refresh: true });
        },
        // error: e => this.errors = e.error?.errors || [e.error?.message]
        error:e=>
        {
          if(e.error?.errors || [e.error?.message])
            {
              this.toastr.error('Oops!', e.error.message);
            }
            else {
              this.toastr.error('Oops!', "Something went wrong");
            }
        }
      })
  }

  LoadCountries(){
    this.countryService.GetActiveCountries().subscribe((res:any)=>{
      this.country=res
      for(let i=0;i<=this.country.length;i++){
        this.countryList.push({label:this.country[i].name,value:this.country[i].id})
      }
    })
  }
}
